export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "en": {
        
      },
      "fr": {
        "ex": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ex-"])}
      }
    }
  })
}
